import useRoutes from "../../hooks/useRoutes";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../providers/AuthProvider";
import { usePortal } from "../../../Providers/PortalProvider";
import I18n from "../../../i18n";
import { generatePath } from "react-router";
import { Link } from "react-router-dom";

const getTitle = (title, userLang, portalLang) => {
  if (typeof title == "string") {
    return title;
  }
  if (title[userLang]) {
    return title[userLang];
  }
  if (title[portalLang]) {
    return title[portalLang];
  }
  return "";
};

const getLinkComponent = (item, routes) => {
  if (item.type == "internal") {
    if (!item.data) {
      item.data = {};
    }
    if (
      item.target == "products.cards" ||
      item.target == "products.cards.category"
    ) {
      item.data.type = "cards";
    } else if (
      item.target == "products.calendars" ||
      item.target == "products.calendars.pages"
    ) {
      item.data.type = "calendars";
    } else if (
      item.target == "products.photogifts" ||
      item.target == "products.photogifts.category"
    ) {
      item.data.type = "photogifts";
    }
    return {
      component: Link,
      to: generatePath(routes[item.target].path, item.data),
    };
  } else if (item.type === "modal") {
    return {
      // We can display default menu redering
    };
  } else {
    return {
      component: "a",
      href: item.target,
    };
  }
};

export default () => {
  const routes = useRoutes();
  const { isAuthenticated } = useAuth();
  const { t } = useTranslation();
  const portal = usePortal();

  // Cache the routes? Because of translations we don't want to reload them all the time?
  const items = useMemo(() => {
    const menu = window.PAGE_SETTINGS.menu
      .filter((item) => {
        // If desktop, ignore
        if (item.device === 2) {
          return false;
        }
        if (item.visibility == 0) {
          return true;
        }
        if (item.visibility == 2 && isAuthenticated == false) {
          return true;
        }
        if (item.visibility == 1 && isAuthenticated == true) {
          return true;
        }
        return false;
      })
      .map((item) => {
        return {
          ...item,
          link: getLinkComponent(item, routes),
          title: getTitle(
            item.title,
            I18n.language.replace("-", "_"),
            portal.locale.default_language.replace("-", "_"),
          ),
          children: item.children.map((childItem) => {
            return {
              ...childItem,
              title: getTitle(
                childItem.title,
                I18n.language.replace("-", "_"),
                portal.locale.default_language.replace("-", "_"),
              ),
              link: getLinkComponent(childItem, routes),
              children: childItem.children
                ? childItem.children.map((grandChild) => ({
                    ...grandChild,
                    title: getTitle(
                      grandChild.title,
                      I18n.language.replace("-", "_"),
                      portal.locale.default_language.replace("-", "_"),
                    ),
                  }))
                : [],
            };
          }),
        };
      });

    menu.push({
      id: "spacer-1",
      type: "spacer",
    });

    menu.push({
      title: t("Contact us"),
      icon: "contact_mail",
      link: {
        component: Link,
        to: routes.contactus.path,
      },
    });

    if (
      portal.terms.termsOfService ||
      portal.terms.termsOfPurchase ||
      portal.webshop.hasPrivacyPolicy
    ) {
      const terms = {
        title: t("Terms & policies"),
        icon: "security",
        type: "parent-without-link",
        children: [],
      };
      menu.push(terms);

      if (
        portal.terms.termsOfService &&
        portal.terms.termsOfService !== "N/A"
      ) {
        terms.children.push({
          title: t("Terms of service"),
          icon: "security",
          link: {
            component: Link,
            to: routes.termsofservice?.path,
          },
        });
      }

      if (portal.webshop.hasPrivacyPolicy) {
        terms.children.push({
          title: t("Privacy policy"),
          icon: "security",
          link: {
            component: Link,
            to: routes.privacypolicy?.path,
          },
        });
      }

      if (
        portal.terms.termsOfPurchase &&
        portal.terms.termsOfPurchase !== "N/A"
      ) {
        terms.children.push({
          title: t("Terms of purchase"),
          icon: "security",
          link: {
            component: Link,
            to: routes.termsofpurchase?.path,
          },
        });
      }
    }

    menu.push({
      title: t("Desktop version"),
      icon: "computer",
      show: 0,
      link: {
        href: "/sections/prophoto/packages.php?desktop",
        component: "a",
      },
    });

    const menuWithId = menu.map((item) => {
      return {
        ...item,
        id: item.id || item.title,
      };
    });

    return menuWithId;
  }, [isAuthenticated, I18n.language]);

  return items;
};
